export const resolveLogoUrl = (rawUrl?: string): string | undefined => {
  const apiBaseUrl =
    process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, "") || "";

  if (!rawUrl) return undefined;

  if (rawUrl.startsWith("/uploads")) {
    return `${apiBaseUrl}${rawUrl}`;
  }

  if (rawUrl.startsWith("http")) {
    return rawUrl;
  }

  return `${apiBaseUrl}/uploads/4axon/logos/${rawUrl}`;
};
